import React, { useState } from 'react';
import HeroImage from '../assets/hero.webp';
import Hero1Image from '../assets/hero1.webp';

const CropPestDiseaseControl = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "फसलों में रोगों का पता कैसे लगाएं?",
      answer: "पत्तियों के रंग में परिवर्तन, धब्बे, मुरझाना, असामान्य वृद्धि, फलों का विकृत होना आदि लक्षणों से रोगों की पहचान करें। नियमित रूप से खेत का निरीक्षण करें और संदिग्ध पौधों के नमूने कृषि विशेषज्ञ को दिखाएं।"
    },
    {
      question: "जैविक कीट नियंत्रण के क्या फायदे हैं?",
      answer: "जैविक विधियाँ पर्यावरण के अनुकूल हैं, मिट्टी की गुणवत्ता बनाए रखती हैं, कीटनाशक अवशेष नहीं छोड़तीं, और लंबे समय में अधिक टिकाऊ होती हैं। यह मानव स्वास्थ्य और लाभकारी कीटों के लिए भी सुरक्षित हैं।"
    },
    {
      question: "रासायनिक उपचार करते समय क्या सावधानियाँ बरतें?",
      answer: "हमेशा सुरक्षात्मक कपड़े पहनें, अनुशंसित मात्रा से अधिक न डालें, हवा की दिशा का ध्यान रखें, छिड़काव के बाद निर्धारित समय तक खेत में प्रवेश न करें, और रसायनों को बच्चों और जानवरों से दूर रखें।"
    },
    {
      question: "क्या नीम का तेल सभी प्रकार के कीटों पर काम करता है?",
      answer: "नीम का तेल 200 से अधिक प्रकार के कीटों के विरुद्ध प्रभावी है, विशेषकर छोटे कीड़े, माइट्स और कुछ कवक रोगों के लिए। हालांकि, यह सभी कीटों के लिए समान रूप से प्रभावी नहीं हो सकता है।"
    },
    {
      question: "फसल चक्र क्यों महत्वपूर्ण है?",
      answer: "फसल चक्र मिट्टी की उर्वरता बनाए रखता है, रोगजनकों और कीटों के जीवन चक्र को तोड़ता है, मिट्टी में पोषक तत्वों का संतुलन बनाए रखता है, और खरपतवार नियंत्रण में मदद करता है।"
    },
    {
      question: "कीट प्रतिरोधी किस्में कैसे मदद करती हैं?",
      answer: "ये किस्में प्राकृतिक रूप से कीटों के विरुद्ध प्रतिरोधक क्षमता रखती हैं, जिससे रासायनिक उपचार की आवश्यकता कम हो जाती है। यह उत्पादन लागत को कम करती हैं और पर्यावरण के लिए बेहतर हैं।"
    }
  ];

  return (
    <div className="mt-20">
      {/* Hero Section */}
      <div className="relative h-[500px] w-full">
        <img 
          src={HeroImage} 
          alt="Farm field" 
          className="w-full h-full object-cover brightness-75"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center px-4">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-yellow-300">
                फसल रोग नियंत्रण
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-white max-w-3xl mx-auto">
              फसलों में लगने वाले प्रमुख रोगों और कीटों की वैज्ञानिक पहचान व आधुनिक नियंत्रण तकनीकें
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Disease Identification Section */}
        <div className="flex flex-col md:flex-row gap-8 items-center mb-16">
          <div className="md:w-1/2">
            <img 
              src={Hero1Image} 
              alt="Crop disease" 
              className="rounded-lg shadow-xl hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-6 text-gray-800 hover:text-green-600 transition-colors duration-300">
              रोगों की पहचान कैसे करें
            </h2>
            <p className="text-lg text-gray-700 mb-4">
              फसलों में रोगों की सही पहचान उचित नियंत्रण की पहली सीढ़ी है। निम्नलिखित विस्तृत लक्षणों पर ध्यान दें:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li className="hover:text-green-700 transition-colors duration-200"><strong>पत्तियों के लक्षण:</strong> पीलेपन, सफेद पाउडर जैसा आवरण, गहरे भूरे धब्बे, छिद्र, किनारों का सूखना</li>
              <li className="hover:text-green-700 transition-colors duration-200"><strong>तने के लक्षण:</strong> काले धब्बे, गलन, सड़न, सफेद फफूंदी दिखाई देना</li>
              <li className="hover:text-green-700 transition-colors duration-200"><strong>जड़ों के लक्षण:</strong> गांठें बनना, सूजन आना, जड़ों का सड़ना, मिट्टी से बदबू आना</li>
              <li className="hover:text-green-700 transition-colors duration-200"><strong>फल/फूल के लक्षण:</strong> विकृत आकार, समय से पहले गिरना, सड़न, रंग परिवर्तन</li>
              <li className="hover:text-green-700 transition-colors duration-200"><strong>कीटों के संकेत:</strong> चिपचिपा पदार्थ, सुरंगें, अंडे के गुच्छे, कीटों का सीधे दिखाई देना</li>
            </ul>
            <div className="mt-6 bg-yellow-50 border-l-4 border-yellow-400 p-4">
              <p className="text-yellow-700"><strong>महत्वपूर्ण:</strong> रोग पहचान के लिए कृषि विस्तार अधिकारी या पादप रोग विशेषज्ञ से सलाह लें। गलत पहचान से गलत उपचार हो सकता है जो समस्या को और बढ़ा सकता है।</p>
            </div>
            <audio controls className="mb-6">
                      <source src="/audio/rog.mp3" type="audio/mp3" />

                   आपका ब्राउज़र ऑडियो को सपोर्ट नहीं करता।
                   </audio> 
          </div>
        </div>

        {/* Organic Control Methods Section */}
        <div className="bg-gradient-to-r from-green-50 to-yellow-50 p-8 rounded-xl mb-16">
          <h2 className="text-3xl font-bold mb-6 text-gray-800 hover:text-green-600 transition-colors duration-300">
            जैविक नियंत्रण विधियाँ
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            जैविक विधियाँ टिकाऊ कृषि का आधार हैं जो पर्यावरण, मानव स्वास्थ्य और मिट्टी की उर्वरता को संरक्षित करती हैं:
          </p>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:border-l-4 hover:border-green-500">
              <h3 className="text-xl font-semibold mb-3 text-green-700">नीम आधारित उत्पाद</h3>
              <p className="text-gray-700 mb-2">
                <strong>तैयारी:</strong> 5ml नीम तेल + 1ml हल्दी पाउडर + 5 लीटर पानी में मिलाकर 15 दिन के अंतराल पर छिड़कें
              </p>
              <p className="text-gray-700">
                <strong>लाभ:</strong> एफिड्स, माइट्स, लीफ माइनर, और कई कवक रोगों के विरुद्ध प्रभावी
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:border-l-4 hover:border-green-500">
              <h3 className="text-xl font-semibold mb-3 text-green-700">पंचगव्य</h3>
              <p className="text-gray-700 mb-2">
                <strong>तैयारी:</strong> गोमूत्र, गोबर, दूध, दही, घी, गुड़ को मिलाकर 21 दिन किण्वित करें
              </p>
              <p className="text-gray-700">
                <strong>लाभ:</strong> पौधों की प्रतिरोधक क्षमता बढ़ाता है, मिट्टी के सूक्ष्मजीवों को सक्रिय करता है
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:border-l-4 hover:border-green-500">
              <h3 className="text-xl font-semibold mb-3 text-green-700">जैविक कीटनाशक</h3>
              <p className="text-gray-700 mb-2">
                <strong>उदाहरण:</strong> बीटी (Bacillus thuringiensis), ब्यूवेरिया बैसियाना, वर्टिसिलियम लेकानी
              </p>
              <p className="text-gray-700">
                <strong>लाभ:</strong> विशिष्ट कीटों को निशाना बनाते हैं, लाभकारी कीटों को नुकसान नहीं पहुंचाते
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:border-l-4 hover:border-green-500">
              <h3 className="text-xl font-semibold mb-3 text-green-700">सहयोगी फसलें</h3>
              <p className="text-gray-700 mb-2">
                <strong>संयोजन:</strong> टमाटर-तुलसी, गोभी-लहसुन, कपास-अलसी, मक्का-सेम
              </p>
              <p className="text-gray-700">
                <strong>लाभ:</strong> कीटों को भ्रमित करती हैं, लाभकारी कीटों को आकर्षित करती हैं, मिट्टी स्वास्थ्य सुधारती हैं
              </p>
            </div>
          </div>
          <div className="mt-8 bg-green-50 p-6 rounded-lg border border-green-200">
            <h3 className="text-xl font-semibold text-green-800 mb-3">जैविक नियंत्रण के अतिरिक्त टिप्स</h3>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>प्रारंभिक अवस्था में ही रोग/कीट का पता लगाकर नियंत्रण शुरू कर दें</li>
              <li>सुबह या शाम के समय छिड़काव करें जब तापमान कम हो</li>
              <li>वैकल्पिक जैविक उपचारों का उपयोग करें ताकि कीट प्रतिरोध विकसित न कर सकें</li>
              <li>खेत में पक्षियों के लिए पेरच लगाएं जो कीटों को खाते हैं</li>
            </ul>
          </div>
        </div>

        {/* Chemical Treatment Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold mb-6 text-gray-800 hover:text-green-600 transition-colors duration-300">
            रासायनिक उपचार (सावधानीपूर्वक उपयोग करें)
          </h2>
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <div className="p-6">
              <p className="text-gray-700 mb-6">
                जब जैविक विधियाँ अपर्याप्त हों, तो रासायनिक उपचार का सावधानी से उपयोग किया जा सकता है। हमेशा कृषि विशेषज्ञ की सलाह से ही रसायनों का चयन करें:
              </p>
              <div className="space-y-6">
                <div className="p-5 border border-gray-200 rounded-lg hover:bg-blue-50 transition-colors duration-300 hover:border-blue-300">
                  <h3 className="text-xl font-semibold text-blue-700 mb-2">कवकनाशी (Fungicides)</h3>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li><strong>मैंकोजेब (0.25%):</strong> पत्ती धब्बा, झुलसा रोग के लिए</li>
                    <li><strong>कार्बेंडाजिम (0.1%):</strong> उकठा रोग, जड़ सड़न के लिए</li>
                    <li><strong>हेक्साकोनाजोल (0.1%):</strong> पाउडरी मिल्ड्यू, रस्ट के लिए</li>
                    <li><strong>कॉपर ऑक्सीक्लोराइड (0.3%):</strong> बैक्टीरियल ब्लाइट, अंगमारी के लिए</li>
                  </ul>
                </div>
                <div className="p-5 border border-gray-200 rounded-lg hover:bg-blue-50 transition-colors duration-300 hover:border-blue-300">
                  <h3 className="text-xl font-semibold text-blue-700 mb-2">कीटनाशक (Insecticides)</h3>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li><strong>इमिडाक्लोप्रिड (0.5ml/L):</strong> चूसक कीटों जैसे एफिड्स, व्हाइटफ्लाई के लिए</li>
                    <li><strong>स्पाइनोसेड (0.4ml/L):</strong> फल छेदक, पत्ती लपेटक कीटों के लिए</li>
                    <li><strong>डायफेन्थियूरॉन (1g/L):</strong> माइट्स, थ्रिप्स के लिए</li>
                    <li><strong>कार्टाप हाइड्रोक्लोराइड (2g/L):</strong> तना छेदक, पत्ती खाने वाले कीटों के लिए</li>
                  </ul>
                </div>
                <div className="p-5 border border-gray-200 rounded-lg hover:bg-blue-50 transition-colors duration-300 hover:border-blue-300">
                  <h3 className="text-xl font-semibold text-blue-700 mb-2">सुरक्षा दिशा-निर्देश</h3>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>हमेशा रसायनों के लेबल पर दिए निर्देशों का पालन करें</li>
                    <li>छिड़काव करते समय पूरे शरीर को ढकने वाले कपड़े, दस्ताने, मास्क और चश्मा पहनें</li>
                    <li>छिड़काव के बाद साबुन से अच्छी तरह स्नान करें</li>
                    <li>रसायनों को मूल कंटेनर में ही रखें और बच्चों/पशुओं की पहुंच से दूर रखें</li>
                    <li>खाली कंटेनरों को सुरक्षित तरीके से नष्ट करें, जलाशयों के पास न फेंके</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Preventive Measures Section */}
        <div className="mb-16 bg-gradient-to-br from-blue-50 to-green-50 p-8 rounded-xl">
          <h2 className="text-3xl font-bold mb-6 text-gray-800">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-green-600">
              रोग निवारक उपाय
            </span>
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white bg-opacity-80 p-5 rounded-lg backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <h3 className="text-xl font-semibold mb-2 text-blue-800">स्वस्थ बीज/पौध सामग्री</h3>
              <p className="text-gray-700">प्रमाणित बीज, रोगमुक्त पौध, और स्वस्थ कटिंग्स का उपयोग करें। बीजोपचार अवश्य करें।</p>
            </div>
            <div className="bg-white bg-opacity-80 p-5 rounded-lg backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <h3 className="text-xl font-semibold mb-2 text-blue-800">मिट्टी स्वास्थ्य प्रबंधन</h3>
              <p className="text-gray-700">जैविक खाद, हरी खाद, और फसल अवशेषों का उपयोग कर मिट्टी में जैविक कार्बन बढ़ाएं।</p>
            </div>
            <div className="bg-white bg-opacity-80 p-5 rounded-lg backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <h3 className="text-xl font-semibold mb-2 text-blue-800">सफाई एवं स्वच्छता</h3>
              <p className="text-gray-700">खेत से रोगग्रस्त पौधों को हटाकर नष्ट करें, औजारों को कीटाणुरहित करें।</p>
            </div>
            <div className="bg-white bg-opacity-80 p-5 rounded-lg backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <h3 className="text-xl font-semibold mb-2 text-blue-800">जल प्रबंधन</h3>
              <p className="text-gray-700">अधिक सिंचाई से बचें, उचित जल निकासी का प्रबंध करें जिससे जड़ सड़न रोकी जा सके।</p>
            </div>
            <div className="bg-white bg-opacity-80 p-5 rounded-lg backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <h3 className="text-xl font-semibold mb-2 text-blue-800">समेकित कीट प्रबंधन (IPM)</h3>
              <p className="text-gray-700">जैविक, यांत्रिक, सांस्कृतिक और रासायनिक विधियों का संतुलित मिश्रण अपनाएं।</p>
            </div>
            <div className="bg-white bg-opacity-80 p-5 rounded-lg backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <h3 className="text-xl font-semibold mb-2 text-blue-800">निगरानी एवं रिकॉर्ड</h3>
              <p className="text-gray-700">रोग/कीटों की नियमित निगरानी करें और उपचारों का रिकॉर्ड रखें ताकि भविष्य में मदद मिल सके।</p>
            </div>
          </div>
        </div>

        {/* FAQ Section with Dropdown */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-600">
              अक्सर पूछे जाने वाले प्रश्न
            </span>
          </h2>
          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="border border-gray-200 rounded-lg overflow-hidden transition-all duration-300 hover:border-purple-400 hover:shadow-md"
              >
                <div 
                  className="p-5 cursor-pointer bg-white flex justify-between items-center"
                  onClick={() => toggleFAQ(index)}
                >
                  <h3 className="text-xl font-semibold text-purple-700">
                    <span className="mr-3">Q{index+1}.</span>
                    {faq.question}
                  </h3>
                  <svg
                    className={`w-6 h-6 text-purple-500 transition-transform duration-300 ${activeIndex === index ? 'transform rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
                <div 
                  className={`px-5 overflow-hidden transition-all duration-300 ${activeIndex === index ? 'max-h-96 pb-5' : 'max-h-0'}`}
                >
                  <p className="text-gray-700 pl-8">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Final Tips Section */}
        <div className="bg-gradient-to-r from-purple-50 to-indigo-50 p-8 rounded-xl">
          <h2 className="text-2xl font-bold mb-4 text-center text-gray-800">अतिरिक्त सुझाव</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white p-5 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
              <h3 className="text-lg font-semibold mb-2 text-indigo-700">समय पर कार्रवाई</h3>
              <p className="text-gray-700">रोग/कीट का पता चलते ही तुरंत उपचार शुरू कर दें। देरी से समस्या बढ़ सकती है और नियंत्रण कठिन हो सकता है।</p>
            </div>
            <div className="bg-white p-5 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
              <h3 className="text-lg font-semibold mb-2 text-indigo-700">स्थानीय ज्ञान का उपयोग</h3>
              <p className="text-gray-700">स्थानीय किसानों के अनुभवों से सीखें और पारंपरिक ज्ञान को आधुनिक तकनीकों के साथ मिलाकर उपयोग करें।</p>
            </div>
          </div>
          <div className="mt-6 text-center">
            <p className="text-gray-700">
              अधिक जानकारी के लिए अपने नजदीकी कृषि विज्ञान केंद्र या कृषि विस्तार अधिकारी से संपर्क करें।
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CropPestDiseaseControl;